import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import RoutesUtils from '../../../../utils/routes';
import { RoutePath } from '../../../../routes/constants';
import HeaderLogo from '../../../../components/MenuManager/Header/Logo';
import { getMenuButtonIconSrc } from '../../../../utils/menuManager';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		galleryInfos,
		offlineManager,
		appInfos,
		routerParamsHistory,
		driveList: { driveItems, resolutions },
		offlineManager: { thumbMap },
	} = state;
	const { icon, label } = ownProps;
	const isMultiApp = Utils.isMultiApp(appInfos);
	const brandLogoUrl = icon
		? getMenuButtonIconSrc(icon, driveItems, galleryInfos.config, thumbMap, resolutions)
		: Utils.getBrandLogoUrl(galleryInfos, offlineManager, false, isMultiApp);
	const brandUrl = label || galleryInfos.template && galleryInfos.template.brand && galleryInfos.template.brand.url;
	const currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
	const isCurrentPageHome = RoutesUtils.doesRoutesContainsPath(RoutePath.Home, currentRoute.routes);

	return {
		brandLogoUrl,
		brandUrl,
		isCurrentPageHome
	};
};

export default connect(mapStateToProps)(HeaderLogo);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/Logo/index.tsx